import { useRef, useEffect } from "react";

// Хук предназначен для запоминания значения функционального компонента, вычисленного во время предыдущего рендеринга.
export const usePrevious = <T>(value: T) => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
